var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFoodContact(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentcolor",
    id: "Group_19",
    "data-name": "Group 19",
    transform: "translate(-220.85 -179)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_9",
    "data-name": "Subtraction 9",
    d: "M-1971.35,32c-.17,0-.342,0-.511-.008,0-.021.009-.1.021-.206.022-.208.057-.54.093-.859.124,0,.257.005.4.005A14.95,14.95,0,0,0-1956.417,16,14.95,14.95,0,0,0-1971.35,1.067,14.951,14.951,0,0,0-1986.284,16a15.09,15.09,0,0,0,.118,1.885l-1.074,0A16.133,16.133,0,0,1-1987.35,16a16.018,16.018,0,0,1,16-16,16.018,16.018,0,0,1,16,16A16.018,16.018,0,0,1-1971.35,32Zm4.931-6.543v0a6.376,6.376,0,0,0,.238-1.122v-.248a9.571,9.571,0,0,0,4.43-8.085,9.611,9.611,0,0,0-9.6-9.6,9.611,9.611,0,0,0-9.6,9.6,9.642,9.642,0,0,0,.183,1.872l-1.085,0a10.736,10.736,0,0,1-.165-1.874A10.679,10.679,0,0,1-1971.35,5.333,10.679,10.679,0,0,1-1960.683,16a10.627,10.627,0,0,1-1.591,5.6,10.738,10.738,0,0,1-4.143,3.857Z",
    transform: "translate(2211.2 179)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M2211.5,191.381h23.339s2.1,10.2-4.55,11.186c-.043-.022-.819,0-.819,0v1.765l-12.66.391v-2.156s-5.177-.966-5.311-5.483C2211.521,197.176,2211.5,191.381,2211.5,191.381Z",
    transform: "translate(-1990.15 6)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M-1984.029,14.413a.55.55,0,0,1-.55-.55V12.449a6.56,6.56,0,0,1-3.841-2.19A6.557,6.557,0,0,1-1990,6V.55c0-.221.187-.394.5-.433a9.1,9.1,0,0,1,1.1-.005c.427.01.954.021,1.587.005,3.3-.08,9.877-.117,20.7-.117h.006a.549.549,0,0,1,.546.554V6a6.562,6.562,0,0,1-1.578,4.26,6.56,6.56,0,0,1-3.841,2.19v1.414a.55.55,0,0,1-.55.55Zm.552-1.1h11.381v-.768h-11.381ZM-1988.9,6a5.459,5.459,0,0,0,5.442,5.441h11.341A5.46,5.46,0,0,0-1966.674,6V1.106H-1988.9Z",
    transform: "translate(2210.85 196.588)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoodContact);
export default __webpack_public_path__ + "static/media/foodContact.ffcd827c981bdc83dd6110b96cdc8d6e.svg";
export { ForwardRef as ReactComponent };